import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { startCase } from 'lodash';

import { env } from '~/commons/config';
import ListResource from './ListResource.jsx';

const api = '/api/core/pre-stocks';

const ListReadyToShip = () => {
  const history = useHistory();

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { updatedAt: -1 },
        actions: {
          create: false,
          remove: false,
        },
        filter: {
          productionStatus: 'ReadyToShip',
          status: 'open',
        },
        onRowClick: (row) => {
          history.push(`pre-stocks/${row._id}`);
        },
        cols: [
          {
            key: 'rawColl',
            sortable: true,
            children: 'Collection',
          },
          {
            key: 'rawDesign',
            sortable: true,
            children: 'Design',
          },
          { key: 'quality', sortable: true },
          { key: 'material', sortable: true },
          { key: 'color', sortable: true },
          { key: 'size', sortable: true },
          {
            key: 'status',
            sortable: true,
            getter: startCase,
          },
          {
            key: 'productionStatus',
            children: 'Prod. Status',
            sortable: true,
            getter: startCase,
          },
          {
            key: 'itemCode',
            sortable: true,
            children: 'Item Code',
          },
          {
            key: 'poNo',
            sortable: true,
            children: 'PO Number',
            dataClass: 'text-nowrap',
          },
          {
            key: 'lineNo',
            sortable: true,
            children: 'Line',
          },
          {
            key: 'exMillDate',
            sortable: true,
            children: 'Ex-Mill Date',
            getter: (v) => (v ? moment(v).format(env.f.d) : ''),
          },
          {
            key: 'updatedAt',
            children: 'Last Updated at',
            sortable: true,
            getter: (v) => (v ? moment(v).format(env.f.d) : ''),
          },
        ],
      }} />
  );
};

export default ListReadyToShip;
